import { Box, Typography } from "@mui/material";
import MainSection from "../../compontents/common/MainSection";

export default function ErrorPage() {
    return (
        <MainSection>
            <Box className="fadeUp" sx={{ textAlign: 'center'}} >
                <Typography fontWeight={700} sx={{ fontSize: {lg: "464px", md: "310px", sm: "170px", xs: "150px"}, lineHeight: 1, padding: "0 0 100px",  }}>
                    404
                </Typography>
                <Typography sx={{ fontSize: {lg: "22px", sm: "16px"}, lineHeight: 1.2, margin: '0 auto' }}>
                    Ooops! Something went wrong. Please go back to homepage.
                </Typography>
            </Box>
        </MainSection>
    );
}